import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/media-buying/world-map.svg'


const _withScopeId = n => (_pushScopeId("data-v-1018a861"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media__hero" }
const _hoisted_2 = {
  id: "geo",
  class: "geo mediabuying-section"
}
const _hoisted_3 = {
  id: "scrollable",
  class: "container"
}
const _hoisted_4 = { class: "geo__text" }
const _hoisted_5 = { class: "mediabuying-section-title" }
const _hoisted_6 = { class: "mediabuying-section-subtitle" }
const _hoisted_7 = { class: "geo__map" }
const _hoisted_8 = { class: "geo__map_wrapper" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_HeroSection = _resolveComponent("HeroSection")!
  const _component_Ticker = _resolveComponent("Ticker")!
  const _component_SourceSection = _resolveComponent("SourceSection")!
  const _component_GeoItem = _resolveComponent("GeoItem")!
  const _component_Advantages = _resolveComponent("Advantages")!
  const _component_ContactForm = _resolveComponent("ContactForm")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_RequestModal = _resolveComponent("RequestModal")!
  const _component_SignUpDialog = _resolveComponent("SignUpDialog")!
  const _component_LoginDialog = _resolveComponent("LoginDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      onLogin: _ctx.onClickLogin,
      onReg: _ctx.onClickReg
    }, null, 8, ["onLogin", "onReg"]),
    _createVNode(_component_HeroSection, { onRequest: _ctx.onClickReg }, null, 8, ["onRequest"]),
    _createVNode(_component_Ticker, {
      text: `${this.$t('mediaBuying.ticker')}  `
    }, null, 8, ["text"]),
    _createVNode(_component_SourceSection, { onRequest: _ctx.onClickReg }, null, 8, ["onRequest"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t('mediaBuying.geo.title')), 1),
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('mediaBuying.geo.subtitle')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_GeoItem, {
            class: "geo__brasil",
            text: "Brazil",
            img: "images/media-buying/flag.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__britain",
            text: "Britain",
            img: "images/media-buying/britain.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__france",
            text: "France",
            img: "images/media-buying/france.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__nigeria",
            text: "Nigeria",
            img: "images/media-buying/nigeria.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__africa",
            text: "Africa",
            img: "images/media-buying/africa.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__kazakhstan",
            text: "Kazakhstan",
            img: "images/media-buying/kazakhstan.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__india",
            text: "India",
            img: "images/media-buying/india.svg"
          }),
          _createVNode(_component_GeoItem, {
            class: "geo__bangladesh",
            text: "Bangladesh",
            img: "images/media-buying/bangladesh.svg"
          }),
          _hoisted_9
        ])
      ])
    ]),
    _createVNode(_component_Ticker, {
      color: "accent",
      text: `${this.$t('mediaBuying.ticker')}  `
    }, null, 8, ["text"]),
    _createVNode(_component_Advantages, { onClickReg: _ctx.onClickReg }, null, 8, ["onClickReg"]),
    _createVNode(_component_ContactForm),
    _createVNode(_component_Footer),
    _createVNode(_component_RequestModal, {
      open: _ctx.isLeaveRequestModalOpen,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isLeaveRequestModalOpen = false))
    }, null, 8, ["open"]),
    _createVNode(_component_SignUpDialog, {
      open: _ctx.showRegDialog,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showRegDialog = false))
    }, null, 8, ["open"]),
    _createVNode(_component_LoginDialog, {
      open: _ctx.showLoginDialog,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showLoginDialog = false))
    }, null, 8, ["open"])
  ]))
}